import {Col, Row} from 'react-bootstrap';

const UploadHistoryField = ({label, children}) => (
  <Row>
    <Col md={6}>
      {label || ''}
      {label && label !== '' && label ? ':' : ''}
    </Col>
    <Col md={6}>
      {children || ''}
    </Col>
  </Row>
);

export default UploadHistoryField;
